import { render, staticRenderFns } from "./AssetPreviewBox.vue?vue&type=template&id=60f811d0&scoped=true&"
import script from "./AssetPreviewBox.vue?vue&type=script&lang=js&"
export * from "./AssetPreviewBox.vue?vue&type=script&lang=js&"
import style0 from "./AssetPreviewBox.vue?vue&type=style&index=0&id=60f811d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f811d0",
  null
  
)

export default component.exports